<div class="py-2 px-3 bg-green color-white">
	<p class="uc text-center fw-600 mb-1">Observatoire régional des mares et leurs réseaux</p>
	<p class="small uc text-center mb-0">Rhône Alpes</p>
</div>
<div id="dashboard-stats" class="pt-3 pb-2 px-3 bb">
	<div class="row">
		<div class="col">
			<p class="text-center mb-0">
				<? if( data.get('pond_nb') ) { ?>
					<a href="#pond/locate" class="badge badge-success number py-3"><?=data.get('pond_nb')?></a>
					<span class="label color-green fw-700 uc">Mares localisées</span>
				<? } else { ?>
					<span class="badge badge-secondary number py-3"><i class="fas fa-ellipsis-h pulse"></i></span>
					<span class="label text-secondary fw-700 uc">Mares localisées</span>
				<? } ?>
			</p>
		</div>
		<div class="col">
			<p class="text-center mb-0">
				<? if( data.get('visit_nb') ) { ?>
					<a href="#pond/search" class="badge badge-success number py-3"><?=data.get('visit_nb')?></a>
					<span class="label color-green fw-700 uc">Visites détaillées</span>
				<? } else { ?>
					<span class="badge badge-secondary number py-3"><i class="fas fa-ellipsis-h pulse"></i></span>
					<span class="label text-seconday fw-700 uc">Visites détaillées</span>
				<? } ?>
			</p>
		</div>
	</div>
</div>
<div id="dashboard-nav">
	<div class="list-group list-group-nav">
		<? if( zone_nb ) { ?>
			<a href="#pond/locate" class="list-group-item list-group-item-action">
				<i class="far fa-fw fa-2x fa-map-marker-plus color-green"></i>
				<span class="pl-2">Ajouter une mare</span>
			</a>
		<? } else { ?>
			<span class="list-group-item disabled">
				<i class="far fa-fw fa-2x fa-map-marker-plus text-secondary"></i>
				<span class="pl-2">Ajouter une mare</span>
			</span>
		<? } ?>
		<? if( pond_nb ) { ?>
			<a href="#pond/search" class="list-group-item list-group-item-action">
				<i class="far fa-fw fa-2x fa-edit color-green"></i>
				<span class="pl-2">Décrire une mare</span>
			</a>
		<? } else { ?>
			<span class="list-group-item disabled">
				<i class="far fa-fw fa-2x fa-edit text-secondary"></i>
				<span class="pl-2">Décrire une mare</span>
			</span>
		<? } ?>
		<? if( app.is('authenticated') ) { ?>
			<a href="#pond/mine" class="list-group-item list-group-item-action">
				<? if( mine_pond_nb ) { ?>
					<span class="fa-layers fa-fw fa-2x">
						<i class="far fa-map-marker-alt color-green"></i>
						<span class="fa-layers-counter fa-layers-bottom-right bg-secondary"><?=mine_pond_nb?></span>
					</span>
				<? } else { ?>
					<i class="far fa-fw fa-2x fa-map-marker-alt color-green"></i>
				<? } ?>
				<span class="pl-2">Mes mares</span>
			</a>
			<a href="#visit/mine" class="list-group-item list-group-item-action">
				<? if( mine_visit_nb ) { ?>
					<span class="fa-layers fa-fw fa-2x">
						<i class="far fa-clipboard-list color-green"></i>
						<span class="fa-layers-counter fa-layers-bottom-right bg-secondary"><?=mine_visit_nb?></span>
					</span>
				<? } else { ?>
					<i class="far fa-fw fa-2x fa-clipboard-list color-green"></i>
				<? } ?>
				<span class="pl-2">Mes descriptions</span>
			</a>
		<? } else { ?>
			<span class="list-group-item disabled">
				<i class="far fa-fw fa-2x fa-map-marker-alt text-secondary"></i>
				<span class="pl-2">Mes mares</span>
			</span>
			<span class="list-group-item disabled">
				<i class="far fa-fw fa-2x fa-clipboard-list text-secondary"></i>
				<span class="pl-2">Mes descriptions</span>
			</span>
		<? } ?>
		<? if( data.has('about') ) { ?>
			<a href="#page/about" class="list-group-item list-group-item-action">
				<i class="far fa-fw fa-2x fa-info-circle color-green"></i>
				<span class="pl-2"><?=data.get('about').name?></span>
			</a>
		<? } else { ?>
			<span class="list-group-item disabled">
				<i class="far fa-fw fa-2x fa-info-circle text-secondary"></i>
				<span class="pl-2">À propos du projet</span>
			</span>
		<? } ?>
	</div>
	<? if( app.is('authenticated') ) { ?>
		<div class="p-3 bg-light bb bt">
			<p class="text-center small mb-0">Vous êtes connecté comme<br/><strong><?=user.get('fullname')?></strong></p>
		</div>
		<div class="list-group list-group-nav">
			<a href="#user/account" class="list-group-item list-group-item-action">
				<i class="far fa-fw fa-2x fa-user-circle color-green"></i>
				<span class="pl-2">Mon compte</span>
			</a>
			<a href="#default/logout" class="list-group-item list-group-item-action">
				<i class="far fa-fw fa-2x fa-sign-out-alt text-secondary"></i>
				<span class="pl-2">Déconnexion</span>
			</a>
		</div>
	<? } else { ?>
		<div class="p-3 bg-light bb bt">
			<p class="text-center small mb-0">Connectez-vous à votre compte<br/><strong>Mares &amp; Libellules</strong></p>
		</div>
		<div class="list-group list-group-nav">
			<a href="#default/login" class="list-group-item list-group-item-action">
				<i class="far fa-fw fa-2x fa-sign-in-alt color-green"></i>
				<span class="pl-2">Connexion</span>
			</a>
			<a href="#user/create" class="list-group-item list-group-item-action">
				<i class="far fa-fw fa-2x fa-user color-green"></i>
				<span class="pl-2">Créer un compte</span>
			</a>
			<a href="https://www.mares-libellules.fr/politique-de-confidentialite.html" target="_blank" class="list-group-item list-group-item-action">
				<i class="far fa-fw fa-2x fa-file-contract color-green"></i>
				<span class="pl-2">Politique de confidentialité</span>
			</a>
		</div>
	<? } ?>
</div>
<!-- <div class="p-3 bg-green color-white">
	<p class="mb-0 text-center">
		<span class="uc">Plus d'infos sur</span>
		<br/><a href="https://www.mares-libellules.fr" target="_blank" class="color-white">www.mares-libellules.fr</a>
		<br/>
		<a href="https://www.mares-libellules.fr/politique-de-confidentialite.html" target="_blank" class="color-white">
			<small>Politique de confidentialité</small>
		</a>
	</p>
</div>
<div class="p-1 text-center bg-white text-muted text-center small">
	<div class="small">v<?=document.documentElement.getAttribute("data-appversion")?></div>
</div> -->
